
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/course/[slug]",
      function () {
        return require("private-next-pages/course/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/course/[slug]"])
      });
    }
  